import React, { type Ref } from 'react';

import { defineMessage, IntlProvider, useIntl } from 'react-intl';

import Button from '@atlaskit/button/default/button';
import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';
import { ModalTrigger } from '@atlassian/entry-points/modal-trigger';

import { loadingModalEntryPoint } from '../fixtures/constellation/loading-modal-entry-point';
import { RelayWrapper } from '../utils/wrapper';

const triggerLabel = defineMessage({
	id: 'entry-points.examples.modal.trigger.ai-non-final',
	defaultMessage: 'Edit issue',
	description: 'Label on the example button that opens the asynchronously loaded edit issue modal.',
});
const modalTitle = defineMessage({
	id: 'entry-points.examples.modal.title.ai-non-final',
	defaultMessage: 'Edit issue',
	description: 'Visible title on the default loading modal while the edit issue content loads.',
});
const loadingMessage = defineMessage({
	id: 'entry-points.examples.modal.loading.ai-non-final',
	defaultMessage: 'Loading issue',
	description:
		'Message displayed while the example modal waits for its edit issue content to load.',
});

const frenchMessages = {
	[triggerLabel.id]: 'Modifier le ticket',
	[modalTitle.id]: 'Modifier le ticket',
	[loadingMessage.id]: 'Chargement du ticket',
};

function TranslatedModal(): React.JSX.Element {
	const { formatMessage } = useIntl();

	return (
		<ModalTrigger
			entryPoint={loadingModalEntryPoint}
			title={formatMessage(modalTitle)}
			loadingText={formatMessage(loadingMessage)}
		>
			{({ ref }) => (
				<Button ref={ref as Ref<HTMLButtonElement>} aria-haspopup="dialog">
					{formatMessage(triggerLabel)}
				</Button>
			)}
		</ModalTrigger>
	);
}

export default function ModalTriggerInternationalization(): React.JSX.Element {
	return (
		<IntlProvider locale="fr" defaultLocale="en" messages={frenchMessages}>
			<RelayWrapper>
				<ModalContextProvider>
					<TranslatedModal />
				</ModalContextProvider>
			</RelayWrapper>
		</IntlProvider>
	);
}
